console.log("index chargé v2");

document.addEventListener('DOMContentLoaded', function () {
  // Enregistrer le plugin ScrollTrigger avec GSAP
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    console.log('GSAP et ScrollTrigger chargés correctement.');
    gsap.registerPlugin(ScrollTrigger);

    $pattern__title = document.querySelectorAll('.pattern__title');
    $index__text = document.querySelectorAll('.index-f-h__text');
    $index__infos = document.querySelectorAll('.index-f-h__infos');
    $index__text_2 = document.querySelectorAll('.index-89-100__text');
    $resultats__text = document.querySelectorAll('.resultats__text');
    $resultats__infos = document.querySelectorAll('.resultats__infos');

    const elements = document.querySelectorAll('.pattern__title, .index-f-h__text, .index-f-h__infos, .index-89-100__text, .resultats__text, .resultats__infos');

    gsap.set(elements, { autoAlpha: 0 });

    elements.forEach(section => {
      console.log("section: ", section);
      gsap.to(section, {
        autoAlpha: 1, // Combine opacity et visibility
        y: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top 80%', // Commence l'animation lorsque le haut de la section atteint 80% de la hauteur de la fenêtre
          end: 'bottom top', // Termine l'animation lorsque le bas de la section atteint le haut de la fenêtre
          toggleActions: 'play none none none', // Joue l'animation à l'entrée et ne fait rien à la sortie
        },
      });
    });

  } else {
    console.error('GSAP ou ScrollTrigger non chargé correctement.');
  }
});


// const tl = gsap.timeline({ delay: 0.5 });
// gsap.set(sections[0].querySelector('.pattern__title'), {
//   x: '-150px',
//   opacity: 0,
// });
// gsap.set(sections[0].querySelector('.index-f-h__text'), {
//   x: '150px',
//   opacity: 0,
// });
// gsap.set(sections[0].querySelector('.index-f-h__infos'), {
//   x: '150px',
//   opacity: 0,
// });
// gsap.set(
//   sections[0].querySelector('.pattern__logo:not(.pattern__logo--mobile)'),
//   {
//     opacity: 0,
//   }
// );
// gsap.set(sections[0].querySelector('.pattern__title'), {
//   '--lineScale': 0,
// });

// tl.to(sections[0].querySelector('.pattern__title'), {
//   x: '0px',
//   opacity: 1,
//   duration: 0.6,
// })
//   .to(
//     sections[0].querySelector('.index-f-h__text'),
//     { x: '0px', opacity: 1, duration: 0.6 },
//     '<'
//   )
//   .to(
//     sections[0].querySelector('.index-f-h__infos'),
//     { x: '0px', opacity: 1, duration: 0.6 },
//     '<'
//   )
//   .to(
//     sections[0].querySelector('.pattern__logo:not(.pattern__logo--mobile)'),
//     { opacity: 1, duration: 0.6 },
//     '<'
//   )
//   .to(
//     sections[0].querySelector('.pattern__title'),
//     {
//       '--lineScale': 1,
//       duration: 0.6,
//     },
//     '-=0.5'
//   )
//   .to(sections, { opacity: 1 });

// function animateSection(sectionIndex, reverse = false) {
//   return new Promise((resolve) => {
//     const timeline = gsap.timeline({
//       onStart: () => {
//         if (!isMobile) {
//           if (!reverse) {
//             // If scrolling down, make the next section visible and bring it to the front
//             if (sections[sectionIndex]) {
//               gsap.set(sections[sectionIndex], { autoAlpha: 1, zIndex: 2 });
//             }
//             // Send the current section to the back
//             if (sections[current]) {
//               gsap.set(sections[current], { zIndex: 1 });
//             }
//           } else {
//             // If scrolling up, make the current section visible and bring it to the front
//             if (sections[current]) {
//               gsap.set(sections[current], { autoAlpha: 1, zIndex: 2 });
//             }
//             // Send the next section to the back
//             if (sections[sectionIndex]) {
//               gsap.set(sections[sectionIndex], { zIndex: 1 });
//             }
//           }

//           if (sectionIndex === 2.5) {
//             gsap.set(sections[3], { autoAlpha: 1, zIndex: 1 });
//             gsap.set(sections[2], { autoAlpha: 1, zIndex: 2 });
//           }
//         }
//       },
//       onComplete: () => {
//         if (!isMobile) {
//           if (!reverse) {
//             // If scrolling down, hide the current section
//             if (sections[current]) {
//               gsap.set(sections[current], { autoAlpha: 0, zIndex: 1 });
//             }
//           } else {
//             // If scrolling up, hide the next section
//             if (sections[sectionIndex]) {
//               gsap.set(sections[sectionIndex], { autoAlpha: 0, zIndex: 1 });
//             }

//             if (sectionIndex === 2.5) {
//               gsap.set(sections[3], { autoAlpha: 0, zIndex: 1 });
//             }
//           }
//         }

//         listening = true;
//         current = sectionIndex;
//         resolve();
//       },
//     });

//     const animations = {
//       0: () => {
//         timeline.to(sections[sectionIndex], {
//           onStart: () => {
//             const tl = gsap.timeline();
//             gsap.set(sections[sectionIndex].querySelector('.pattern__right'), {
//               x: isMobile ? '0%' : '100%',
//             });
//             gsap.set(sections[sectionIndex].querySelector('.pattern__left'), {
//               x: isMobile ? '0%' : '-100%',
//             });
//             gsap.set(sections[sectionIndex].querySelector('.pattern__title'), {
//               x: '-150px',
//               opacity: 0,
//             });
//             gsap.set(sections[sectionIndex].querySelector('.index-f-h__text'), {
//               x: '150px',
//               opacity: 0,
//             });
//             gsap.set(
//               sections[sectionIndex].querySelector('.index-f-h__infos'),
//               {
//                 x: '150px',
//                 opacity: 0,
//               }
//             );
//             gsap.set(
//               sections[sectionIndex].querySelector(
//                 '.pattern__logo:not(.pattern__logo--mobile)'
//               ),
//               {
//                 opacity: 0,
//               }
//             );
//             gsap.set(sections[sectionIndex].querySelector('.pattern__title'), {
//               '--lineScale': 0,
//             });

//             if (!isMobile) {
//               gsap.set(
//                 [
//                   document.querySelector('.header__logo'),
//                   document.querySelector('.header__toggle'),
//                 ],
//                 {
//                   autoAlpha: 1,
//                 }
//               );
//             }

//             tl.to(sections[sectionIndex].querySelector('.pattern__right'), {
//               x: '0%',
//               duration: 0.8,
//             })
//               .to(
//                 sections[sectionIndex].querySelector('.pattern__left'),
//                 { x: '0%', duration: 0.8 },
//                 '<'
//               )
//               .to(sections[sectionIndex].querySelector('.pattern__title'), {
//                 x: '0px',
//                 opacity: 1,
//                 duration: 0.6,
//               })
//               .to(
//                 sections[sectionIndex].querySelector('.index-f-h__text'),
//                 { x: '0px', opacity: 1, duration: 0.6 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector('.index-f-h__infos'),
//                 { x: '0px', opacity: 1, duration: 0.6 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector(
//                   '.pattern__logo:not(.pattern__logo--mobile'
//                 ),
//                 { opacity: 1, duration: 0.6 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector('.pattern__title'),
//                 {
//                   '--lineScale': 1,
//                   duration: 0.6,
//                 },
//                 '-=0.5'
//               );

//             const totalDuration = tl.duration();
//             timeline.to(sections[sectionIndex], {
//               duration: totalDuration,
//             });
//           },
//         });
//       },
//       1: () => {
//         timeline.to(sections[sectionIndex], {
//           onStart: () => {
//             const tl = gsap.timeline();
//             gsap.set(sections[sectionIndex].querySelector('.pattern__right'), {
//               x: isMobile ? '0%' : '100%',
//             });
//             gsap.set(sections[sectionIndex].querySelector('.pattern__left'), {
//               x: isMobile ? '0%' : '-100%',
//             });
//             gsap.set(sections[sectionIndex].querySelector('.pattern__title'), {
//               x: '-150px',
//               opacity: 0,
//             });
//             gsap.set(
//               sections[sectionIndex].querySelector('.index-89-100__text'),
//               {
//                 x: '150px',
//                 opacity: 0,
//               }
//             );
//             gsap.set(
//               sections[sectionIndex].querySelector(
//                 '.pattern__logo:not(.pattern__logo--mobile)'
//               ),
//               {
//                 opacity: 0,
//               }
//             );
//             gsap.set(sections[sectionIndex].querySelector('.pattern__title'), {
//               '--lineScale': 0,
//             });

//             if (!isMobile) {
//               gsap.set(
//                 [
//                   document.querySelector('.header__logo'),
//                   document.querySelector('.header__toggle'),
//                 ],
//                 {
//                   autoAlpha: 0,
//                 }
//               );
//             }

//             tl.to(sections[sectionIndex].querySelector('.pattern__right'), {
//               x: '0%',
//               duration: 0.8,
//             })
//               .to(
//                 sections[sectionIndex].querySelector('.pattern__left'),
//                 { x: '0%', duration: 0.8 },
//                 '<'
//               )
//               .to(sections[sectionIndex].querySelector('.pattern__title'), {
//                 x: '0px',
//                 opacity: 1,
//                 duration: 0.6,
//               })
//               .to(
//                 sections[sectionIndex].querySelector('.index-89-100__text'),
//                 { x: '0px', opacity: 1, duration: 0.6 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector(
//                   '.pattern__logo:not(.pattern__logo--mobile'
//                 ),
//                 { opacity: 1, duration: 0.6 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector('.pattern__title'),
//                 {
//                   '--lineScale': 1,
//                   duration: 0.6,
//                 },
//                 '-=0.5'
//               );

//             const totalDuration = tl.duration();
//             timeline.to(sections[sectionIndex], {
//               duration: totalDuration,
//             });
//           },
//         });
//       },
//       2: () => {
//         timeline.to(sections[sectionIndex], {
//           onStart: () => {
//             const tl = gsap.timeline();
//             gsap.set(sections[sectionIndex].querySelector('.pattern__right'), {
//               x: isMobile ? '0%' : '100%',
//             });
//             gsap.set(sections[sectionIndex].querySelector('.pattern__left'), {
//               x: isMobile ? '0%' : '-100%',
//             });
//             gsap.set(sections[sectionIndex].querySelector('.pattern__title'), {
//               x: '-150px',
//               opacity: 0,
//             });
//             gsap.set(sections[sectionIndex].querySelector('.resultats__text'), {
//               x: '150px',
//               opacity: 0,
//             });
//             gsap.set(
//               sections[sectionIndex].querySelector('.resultats__infos'),
//               {
//                 x: '150px',
//                 opacity: 0,
//               }
//             );
//             gsap.set(
//               sections[sectionIndex].querySelector(
//                 '.pattern__logo:not(.pattern__logo--mobile)'
//               ),
//               {
//                 opacity: 0,
//               }
//             );
//             gsap.set(sections[sectionIndex].querySelector('.pattern__title'), {
//               '--lineScale': 0,
//             });

//             tl.to(sections[sectionIndex].querySelector('.pattern__right'), {
//               x: '0%',
//               duration: 0.8,
//             })
//               .to(
//                 sections[sectionIndex].querySelector('.pattern__left'),
//                 { x: '0%', duration: 0.8 },
//                 '<'
//               )
//               .to(sections[sectionIndex].querySelector('.pattern__title'), {
//                 x: '0px',
//                 opacity: 1,
//                 duration: 0.6,
//               })
//               .to(
//                 sections[sectionIndex].querySelector('.resultats__text'),
//                 { x: '0px', opacity: 1, duration: 0.6 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector('.resultats__infos'),
//                 { x: '0px', opacity: 1, duration: 0.6 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector(
//                   '.pattern__logo:not(.pattern__logo--mobile'
//                 ),
//                 { opacity: 1, duration: 0.6 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector('.pattern__title'),
//                 {
//                   '--lineScale': 1,
//                   duration: 0.6,
//                 },
//                 '-=0.5'
//               );

//             const totalDuration = tl.duration();
//             timeline.to(sections[sectionIndex], {
//               duration: totalDuration,
//             });
//           },
//         });
//       },
//       2.5: () => {
//         timeline.to(sections[2], {
//           onStart: () => {
//             const tl = gsap.timeline();

//             gsap.set(
//               sections[2].querySelector(
//                 '.pattern__logo:not(.pattern__logo--mobile'
//               ),
//               {
//                 opacity: 0,
//               }
//             );

//             tl.to(sections[2].querySelector('.pattern__right'), {
//               x: isMobile ? '0%' : '100%',
//               duration: 0.8,
//             })
//               .to(
//                 sections[2].querySelector('.pattern__left'),
//                 { x: isMobile ? '0%' : '-100%', duration: 0.8 },
//                 '<'
//               )
//               .to(
//                 sections[2].querySelector(
//                   '.pattern__logo:not(.pattern__logo--mobile'
//                 ),
//                 { opacity: 0, duration: 0 },
//                 '<'
//               );

//             gsap.set(sections[3], {
//               opacity: 1,
//             });
//             gsap.set(sections[3].querySelector('.footer__img > a'), {
//               opacity: 0,
//               y: '70px',
//             });
//             gsap.set(sections[3].querySelector('.footer__img > svg'), {
//               x: '35%',
//             });
//             gsap.set(sections[3].querySelector('.footer__img > svg > g'), {
//               opacity: 0,
//             });
//             gsap.set(
//               sections[3].querySelector(
//                 '.footer__img > svg > g > path:first-of-type'
//               ),
//               {
//                 x: '-150px',
//               }
//             );
//             gsap.set(
//               sections[3].querySelector(
//                 '.footer__img > svg > g > path:last-of-type'
//               ),
//               {
//                 x: '-310px',
//               }
//             );

//             const totalDuration = tl.duration();
//             timeline.to(sections[sectionIndex], {
//               duration: totalDuration,
//             });
//           },
//         });
//       },
//       3: () => {
//         timeline.to(sections[sectionIndex], {
//           onStart: () => {
//             CustomEase.create('custom', 'M0,0 C0.126,0.382 0.277,1 1,1');
//             const tl = gsap.timeline();

//             tl.to(sections[sectionIndex].querySelector('.footer__img > svg'), {
//               x: '0%',
//               duration: 0.5,
//               ease: 'custom',
//             })
//               .to(
//                 sections[sectionIndex].querySelector('.footer__img > svg > g'),
//                 {
//                   opacity: 1,
//                   duration: 0.5,
//                   ease: 'custom',
//                 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector(
//                   '.footer__img > svg > g > path:first-of-type'
//                 ),
//                 {
//                   x: '0px',
//                   duration: 0.5,
//                   ease: 'custom',
//                 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector(
//                   '.footer__img > svg > g > path:last-of-type'
//                 ),
//                 {
//                   x: '0px',
//                   duration: 0.5,
//                   ease: 'custom',
//                 },
//                 '<'
//               )
//               .to(
//                 sections[sectionIndex].querySelector('.footer__img > a'),
//                 { opacity: 1, duration: 0.5, y: '0px', ease: 'custom' },
//                 '<'
//               );

//             const totalDuration = tl.duration();
//             timeline.to(sections[sectionIndex], {
//               duration: totalDuration,
//             });
//           },
//         });
//       },
//       // Define animations for other sections as needed
//     };

//     animations[sectionIndex]?.(); // Execute the animation for the targeted section
//   });
// }

// function handleDirection() {
//   if (!listening) return;

//   if (isMobile) return;

//   listening = false;
//   const goingBackwards = next < current;

//   if (direction === 'down' && next < sections.length - 1) {
//     if (current === 2) {
//       queueAnimation(2.5);
//       next++;
//       queueAnimation(next, goingBackwards);
//     } else {
//       next++;
//       queueAnimation(next, goingBackwards);
//     }
//   } else if (direction === 'up' && next > 0) {
//     next--;
//     queueAnimation(next, goingBackwards);
//   } else {
//     listening = true;
//     return;
//   }
// }
